import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ROUTES } from "constants/index";
import { Button } from "components/ui";
import video1 from "assets/images/website/features-management.svg";
import video2 from "assets/videos/website/howItWorks2.mp4";
import image from "assets/images/website/DashBoard-blur.png";

const steps = [
  {
    title: "Create your company",
    desc: "Sign up and set your brand, logo, and company details in minutes.",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 21h18M5 21V7a2 2 0 012-2h10a2 2 0 012 2v14M9 10h6M9 14h6" />
      </svg>
    )
  },
  {
    title: "Buy licenses",
    desc: "Choose a package that fits your team size. Scale up anytime.",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c1.657 0 3-1.343 3-3S13.657 2 12 2 9 3.343 9 5s1.343 3 3 3zM4 22a8 8 0 1116 0H4z" />
      </svg>
    )
  },
  {
    title: "Add users & employees",
    desc: "Invite admins and managers. Import employees in bulk or add manually.",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-5-3.87M9 20H4v-2a4 4 0 015-3.87M12 12a4 4 0 100-8 4 4 0 000 8z" />
      </svg>
    )
  },
  {
    title: "Generate ID cards",
    desc: "Customize templates and issue verified QR codes for each employee.",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 7h18M3 12h18M3 17h18M8 7v10" />
      </svg>
    )
  },
  {
    title: "Verify anywhere",
    desc: "Scan the QR to confirm identity and validity in real-time.",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 7h4v4H4zM10 7h4v4h-4zM4 13h4v4H4zM16 7h4M16 11h4M10 13h4M16 15h4M16 19h4" />
      </svg>
    )
  },
  {
    title: "Admin oversight",
    desc: "Platform admins can manage companies, licenses, and compliance.",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2 4 4L21 4l-2-2L9 12l-4-4-2 2zM3 21h18" />
      </svg>
    )
  }
];

const HowItWorks: React.FC = () => {
  return (
    // <section className="bg-white/70 dark:bg-secondary-900/40 ">
    //   <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
    //     <div className="max-w-2xl">
    //       <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-secondary-900 dark:text-white">How it works</h2>
    //       <p className="mt-2 text-sm sm:text-base text-secondary-600 dark:text-secondary-300">From company creation to license management and secure verification.</p>
    //     </div>

        
    //     <div className="flex flex-col gap-4 w-full">
    //       <div className="bg-gray-50 p-2 rounded-[20px] flex md:flex-row flex-col-reverse w-full">
    //         <div className="flex-1 md:p-[64px] px-3 py-6 flex-col justify-between flex items-start">
    //           <div>
    //             <div className="h-12 w-12 rounded-100 bg-black text-gray-300 text-[20px] font-[500] flex items-center justify-center">
    //               1
    //             </div>
    //             <p className="pt-6 pb-4 text-[24px] leading-[31px] tracking-[-0.5px] md:text-[28px] md:leading-[35px] md:tracking-[-0.6px]">
    //               Create your card
    //             </p>
    //             <p className="text-[16px] leading-[22px] font-[400] text-gray-700">
    //               Design a personalized digital card in minutes using 30+ premium templates—or craft a fully branded version for your entire team.
    //             </p>
    //           </div>
    //           <p className="text-[12px] leading-[17px] md:text-[14px] md:leading-[19px] md:font-[400] md:tracking-[-0.1px] text-gray-500 pt-6">
    //             Your final card will stay consistent, professional, and aligned with your brand identity across every interaction.
    //           </p>
    //         </div>
    //         <div className="flex-1 bg-gray-100 rounded-[20px] p-4 md:px-[64px] justify-center items-center flex">
    //           <div className="relative overflow-hidden rounded-[30px] flex items-center justify-center border-4 border-[#393836]">
    //             {/* <video
    //               autoPlay
    //               playsInline
    //               muted
    //               loop
    //               preload="auto"
    //               className="w-[194px] h-[420px] object-cover"
    //             >
    //               <source
    //                 src={video1}
    //                 type="video/mp4"
    //               />
    //               Your browser does not support the video tag.
    //             </video> */}
    //             <img src={video1} alt="Feature Management" className="w-[194px] h-[420px] object-contain" />
    //             <div className="absolute h-10 w-20 bg-white top-[2px] left-[calc(50%-40px)]"></div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="bg-gray-50 p-2 rounded-[20px] flex md:flex-row flex-col w-full">
    //         <div className="flex-1 bg-gray-100 rounded-[20px] p-4 md:px-[64px] justify-center items-center flex">
    //           <div className="relative overflow-hidden rounded-[30px] flex items-center justify-center border-4 border-[#393836]">
    //             {/* <video
    //               autoPlay
    //               playsInline
    //               muted
    //               loop
    //               preload="auto"
    //               className="w-[194px] h-[420px] object-cover"
    //             >
    //               <source
    //                 src={video2}
    //                 type="video/mp4"
    //               />
    //               Your browser does not support the video tag.
    //             </video> */}
                
    //             <img src={video1} alt="Feature Management" className="w-[194px] h-[420px] object-contain" />
    //             <div className="absolute h-10 w-20 bg-white top-[2px] left-[calc(50%-40px)]"></div>
    //           </div>
    //         </div>
    //         <div className="flex-1 md:p-[64px] px-3 py-6 flex-col justify-between flex items-start">
    //           <div>
    //             <div className="h-12 w-12 rounded-100 bg-black text-gray-300 text-[20px] font-[500] flex items-center justify-center">
    //               2
    //             </div>
    //             <p className="pt-6 pb-4 text-[24px] leading-[31px] tracking-[-0.5px] md:text-[28px] md:leading-[35px] md:tracking-[-0.6px]">
    //               Add Users
    //             </p>
    //             <p className="text-[16px] leading-[22px] font-[400] text-gray-700">
    //               Make networking effortless by allowing visitors who save your card to share their contact details with a single click.
    //             </p>
    //           </div>
    //           <p className="text-[12px] leading-[17px] md:text-[14px] md:leading-[19px] md:font-[400] md:tracking-[-0.1px] text-gray-500 pt-6">
    //             Enable Lead Capture to gather visitor information instantly—turning every interaction into a valuable opportunity
    //           </p>
    //         </div>
    //       </div>
    //       <div className="bg-gray-50 p-2 rounded-[20px] flex md:flex-row flex-col-reverse w-full">
    //         <div className="flex-1 md:p-[64px] px-3 py-6 flex-col justify-between flex items-start">
    //           <div>
    //             <div className="h-12 w-12 rounded-100 bg-black text-gray-300 text-[20px] font-[500] flex items-center justify-center">
    //               3
    //             </div>
    //             <p className="pt-6 pb-4 text-[24px] leading-[31px] tracking-[-0.5px] md:text-[28px] md:leading-[35px] md:tracking-[-0.6px]">
    //               Share your profile
    //             </p>
    //             <p className="text-[16px] leading-[22px] font-[400] text-gray-700">
    //               Share your digital profile anywhere—via QR code, link, or NFC card—so people can connect with you instantly.
    //             </p>
    //           </div>
    //           <p className="text-[12px] leading-[17px] md:text-[14px] md:leading-[19px] md:font-[400] md:tracking-[-0.1px] text-gray-500 pt-6">
    //             Your shared profile adapts to every platform, making it easy for others to access your info and engage with your brand.
    //           </p>
    //         </div>
    //         <div className="flex-1 bg-gray-100 rounded-[20px] p-4 md:px-[64px] justify-center items-center flex">
    //           <div className="relative overflow-hidden rounded-[30px] flex items-center justify-center border-4 border-[#393836]">
    //             {/* <video
    //               autoPlay
    //               playsInline
    //               muted
    //               loop
    //               preload="auto"
    //               className="w-[194px] h-[420px] object-cover"
    //             >
    //               <source
    //                 src={video1}
    //                 type="video/mp4"
    //               />
    //               Your browser does not support the video tag.
    //             </video> */}
    //             <img src={video1} alt="Feature Management" className="w-[194px] h-[420px] object-contain" />
    //             <div className="absolute h-10 w-20 bg-white top-[2px] left-[calc(50%-40px)]"></div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="mt-8 sm:mt-10">
    //       <Link to={ROUTES.PRICING} className="inline-block w-full sm:w-auto"><Button size="lg" className="w-full sm:w-auto">View pricing & licenses</Button></Link>
    //     </div>
    //   </div>
    // </section>
    <section className="bg-white/70 dark:bg-secondary-900/40 py-24 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
                <div>
                    <h2 className="text-4xl font-bold mb-8 text-primary-800">Ready in 5 Easy Steps</h2>
                    <div className="space-y-8">
                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full border border-primary-500 flex items-center justify-center text-secondary-400 font-bold">1</div>
                            <div>
                                <h4 className="font-bold text-lg text-primary-700">Company Profile</h4>
                                <p className="text-slate-400">Set up your brand identity and administrative roles.</p>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full border border-primary-500 flex items-center justify-center text-secondary-400 font-bold">2</div>
                            <div>
                                <h4 className="font-bold text-lg text-primary-700">Acquire Licenses</h4>
                                <p className="text-slate-400">Scale precisely with what your organization needs.</p>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full border border-primary-500 flex items-center justify-center text-secondary-400 font-bold">3</div>
                            <div>
                                <h4 className="font-bold text-lg text-primary-700">Employee Import</h4>
                                <p className="text-slate-400">Bulk upload your team via CSV or API integration.</p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-6 sm:mt-8 justify-center sm:justify-start items-center flex">
                    <NavLink to={ROUTES.REGISTER} className="mt-12 bg-secondary-300 text-primary-900 px-8 py-3 rounded-xl font-bold hover:bg-secondary-200 transition">Learn More</NavLink>
                    </div>
                </div>
                <div className="bg-[#F6F7F9] rounded-3xl p-8">
                    <div className="flex justify-between items-center mb-6">
                        <span className="text-md font-bold text-primary-500 uppercase tracking-widest">Company's Dashboard</span>
                        <div className="flex space-x-2">
                            <div className="w-3 h-3 bg-secondary-300 rounded-full"></div>
                            <div className="w-3 h-3 bg-secondary-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-secondary-500 rounded-full"></div>
                        </div>
                    </div>
                    <div className="relative">
                    <img 
                      src={image} 
                      alt="Blurred Admin Dashboard" 
                      className="w-full h-auto rounded-xl shadow-sm"
                    />
                  </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default HowItWorks;


